import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatBytes(bytes: number, decimals = 2): string {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

export function isURL(str: string) {
  try {
    new URL(str);
    return true;
  } catch {
    return false;
  }
}

export function formatFileSize(bytes: number) {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
}

// File validation helpers
export const isValidFileType = (
  file: File,
  allowedTypes: string[]
): boolean => {
  if (!allowedTypes || allowedTypes.length === 0) return true; // No restriction
  return allowedTypes.some((type) => {
    if (type.endsWith("/*")) {
      // Wildcard like image/*
      return file.type.startsWith(type.slice(0, -2));
    }
    return file.type === type;
  });
};

export const isValidFileSize = (
  file: File,
  maxSizeInBytes: number
): boolean => {
  return file.size <= maxSizeInBytes;
};

export function formatCurrency(amount: number) {
  return amount.toFixed(2);
}

export function copyToClipboard(
  text: string,
  onSuccess: (result?: any, ...args: any[]) => any,
  onFailure: (error: any, ...args: any[]) => any
) {
  if (!navigator.clipboard || !navigator.clipboard.writeText) return;

  navigator.clipboard
    .writeText(text)
    .then((result) => onSuccess(result))
    .catch((err) => onFailure(err));
}

export function tryParseJSON(jsonString: string, defaultValue = null) {
  try {
    const parsed = JSON.parse(jsonString);
    return parsed;
  } catch (error) {
    return defaultValue;
  }
}
